import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs, Button } from '@blueprintjs/core';
import { Tooltip2, Classes } from '@blueprintjs/popover2';

import RealByCorpus from './RealByCorpus';
import RealGlobal from './RealGlobal';

const extractRealSpec = (stats,subCorpora) => {
  var realSpec={};
  const realizations=Object.keys(stats.realizations).sort();
  for (var i=0;i<realizations.length;i++) {
    const realization=realizations[i];
    realSpec[realization]={};
    for (var j=0;j<subCorpora.length;j++) {
      const subCorpus=subCorpora[j];
      //console.log(realization+" "+subCorpus);
      if (stats.byCorpus[subCorpus] && stats.byCorpus[subCorpus]['realizations'] && stats.byCorpus[subCorpus]['realizations'][realization]) {
        realSpec[realization][subCorpus]=stats.byCorpus[subCorpus]['realizations'][realization]['spec'];
        //console.log(realization+" "+subCorpus+"="+toString(stats.byCorpus[subCorpus]['realizations'][realization]['spec']))
      }
    }
  }
  
  return realSpec;
}


class Realizations extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId:Object.keys(this.props.stats.byCorpus).length===1? Object.keys(this.props.stats.byCorpus)[0]:"Global",
    displayShortName:false,
  }

  handleTabChange = (tabId) => {
    if (tabId !=="displayShortName") {
      this.setState({ selectedTabId: tabId });
      //  this trick is to cope with the react-apex-chart show problem
      window.dispatchEvent(new Event('resize'));
    }
  }

  
  render() {
    const { stats, t, subCorpora } = this.props;

    const tabs = [];
    const displayShortName=this.state.displayShortName;
    const plusOrMinus=displayShortName? "+":"-";
    const plusOrMinusTab=
        <Tab key="displayShortName" id="displayShortName" title={null} panel={null} >
          <Button small={true} onClick={()=>{this.setState({displayShortName:!this.state.displayShortName})}}>{plusOrMinus}</Button>
        </Tab>;
    tabs.push(plusOrMinusTab);

    // grouping realization specificities in a single hash
    const realSpec=extractRealSpec(this.props.stats,subCorpora);

    // generate the global page, only when more than one page
    if (Object.keys(stats.byCorpus).length > 1) {
      const stat = <RealGlobal 
                      corpusStats={this.props.stats} 
                      realSpec={realSpec} 
                      estimatedResults={this.props.estimatedResults["_global_"]}
                      sessionId={this.props.sessionId}
                    />;
      const tab = <Tab key='Global' id='Global' title={t('global')} panel={stat} />;
      tabs.push(tab);
    } else {
      // when there is only one page, some data should be copied from the global stats to the subCorpus
      stats.byCorpus[subCorpora[0]].realizations=stats.realizations;
    }

    // generate the indidual stat pages (sub-corpus or partition)

    for (var i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];
      if (stats.byCorpus[subCorpus].freq) {
        const title=(displayShortName) ? (" "+(i+1).toString()).slice(-2):subCorpus;
        const detailStats="freqByReal";
        const stat =  <RealByCorpus 
                          name={subCorpus}
                          displayShortName={displayShortName}
                          corpusStats={stats.byCorpus[subCorpus]} 
                          realSpec={realSpec} 
                          detailStats={detailStats}
                          estimatedResults={this.props.estimatedResults[subCorpus]}
                      />;
        const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={stat} >
                      {displayShortName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                    </Tab>;
        tabs.push(tab);
      }
    }

    return (
      <>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId} renderActiveTabPanelOnly >
          {tabs}
        </Tabs>
      </>
    );
  }
}

Realizations.propTypes = {
  subCorpora:PropTypes.array,
  stats: PropTypes.object,
  estimatedResults: PropTypes.object,
  csvDelimiter:PropTypes.string,
  sessionId:PropTypes.string,
};

export default withTranslation()(Realizations);
